module.exports = new __parcel__URL__("recruitment_en.1caa9cfb.webp").toString();